











































































































import { Vue, Component, Watch } from 'vue-property-decorator';

import MemberStatusGrid from '@/components/period/member/content/MemberStatusGrid.vue';
import NcpTable from '@/components/table/NcpTable.vue';
import { toI18n } from '@/utils/commonUtils';

import { namespace } from 'vuex-class';
import { getPercentage } from '@/utils/mathUtils';
import { GetStatisticMembersSummaryByPeriod, StatisticSummary, StatisticSummaryByPeriod } from 'supporter';
import { Query } from '@/types/memberStatistic';

const statisticModule = namespace('memberStatistic');

@Component({
  components: {
    NcpTable,
    MemberStatusGrid,
  },
})
export default class ContentWrap extends Vue {
  @statisticModule.State('query') private query!: Query;
  @statisticModule.State('statisticMembersSummaryByPeriodResponse')
  private statisticMembersSummaryByPeriodResponse!: GetStatisticMembersSummaryByPeriod;
  @statisticModule.Getter('syncIdProviders') private syncIdProviders!: string[];

  isCurrentMonth(): boolean {
    if (this.query.dateType !== 'MONTH') return false;
    const queryMonth = new Date(this.query.retStartYmd).getMonth();
    const currentMonth = new Date().getMonth();

    return queryMonth === currentMonth;
  }

  @Watch('statisticMembersSummaryByPeriodResponse', {
    immediate: false,
    deep: true,
  })
  ifStatisticMembersSummaryByPeriodResponse() {
    const summary = this.statisticMembersSummaryByPeriodResponse.statisticSummary;
    const summaryPeriod = this.statisticMembersSummaryByPeriodResponse.statisticSummaryByPeriod;

    this.renderMemberTotalData(summary, summaryPeriod);
    this.renderMarketingData(summary);
    this.renderMemberData(summary, summaryPeriod);
    this.renderGenderData(summary, summaryPeriod);
    this.renderJoinRouteData(summary, summaryPeriod);
  }

  private memberTotalData = [
    {
      key: 'totalMemberCount',
      thData: [{ content: 'STATISTIC_MEMBER_MEMBER_COUNT' }],
      tdData: [
        { content: '0', labelName: 'allPeriodMemberCount' },
        { content: '0', labelName: 'searchDateMemberCount' },
        { content: '0.00', labelName: 'searchDateMemberRate' },
      ],
    },
  ];

  private renderMemberTotalData(summary: StatisticSummary, summaryPeriod: StatisticSummaryByPeriod): void {
    this.memberTotalData.map(data => {
      const key: string = data.key;

      data.tdData[0].content = summary[key];
      data.tdData[1].content = summaryPeriod[key];
      data.tdData[2].content = getPercentage(summary[key], summaryPeriod[key]).toFixed(2);
    });
  }

  private marketingData = [
    {
      schema: 'marketingAgreement',
      thData: [{ content: 'STATISTIC_MEMBER_MEMBER_COUNT' }],
      tdData: [
        { content: '0', labelName: 'allPeriodMemberCount' },
        { content: '0', labelName: 'smsAgreeMembers' },
        { content: '0', labelName: 'dmAgreeMembers' },
        { content: '0', labelName: 'pushAgreeMembers' },
      ],
    },
    {
      schema: 'marketingAgreement',
      thData: [{ content: 'STATISTIC_MEMBER_RATE_OF_TOTAL_MEMBER' }],
      tdData: [
        { content: '0.00', labelName: 'allPeriodMemberRate' },
        { content: '0.00', labelName: 'smsAgreeMemberRate' },
        { content: '0.00', labelName: 'dmAgreeMemberRate' },
        { content: '0.00', labelName: 'pushAgreeMemberRate' },
      ],
    },
  ];

  private renderMarketingData(summary: StatisticSummary): void {
    this.marketingData.map((data, i) => {
      const schema: string = data.schema;

      if (i === 0) {
        data.tdData[0].content = String(summary.totalMemberCount);
        data.tdData[1].content = summary[schema].smsAgreedCount;
        data.tdData[2].content = summary[schema].emailAgreedCount;
        data.tdData[3].content = summary[schema].appPushAgreedCount;
      } else {
        data.tdData[0].content = getPercentage(summary.totalMemberCount, summary.totalMemberCount).toFixed(2);
        data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[schema].smsAgreedCount).toFixed(2);
        data.tdData[2].content = getPercentage(summary.totalMemberCount, summary[schema].emailAgreedCount).toFixed(2);
        data.tdData[3].content = getPercentage(summary.totalMemberCount, summary[schema].appPushAgreedCount).toFixed(2);
      }
    });
  }

  private memberDataTdFormat = () => [
    { content: '0', labelName: 'allPeriodMemberCount' },
    { content: '0.00', labelName: 'allPeriodMemberRate' },
    { content: '0', labelName: 'searchDateMemberCount' },
    { content: '0.00', labelName: 'allPeriodMemberRate' },
    { content: '0.00', labelName: 'searchDateMemberRate' },
    { content: '0.00', labelName: 'searchDateMemberRate' },
  ];
  private commonMemberData = [
    {
      key: 'totalMemberCount',
      thData: [{ content: 'STATISTIC_MEMBER_TOTAL' }],
      tdData: this.memberDataTdFormat(),
    },
    {
      key: 'mallMemberCount',
      schema: 'memberType',
      thData: [{ content: 'STATISTIC_MEMBER_MALL' }],
      tdData: this.memberDataTdFormat(),
    },
  ];
  private memberData = [...this.commonMemberData];

  private getSyncIdMemberData = (syncIdProviders: string[]) => {
    const temp: any[] = [];
    syncIdProviders.forEach(key => {
      temp.push({
        key,
        schema: 'syncIdMembersCount',
        thData: [{ content: 'STATISTIC_MEMBER_' + key.toUpperCase() + '_ID_MEMBER' }],
        tdData: this.memberDataTdFormat(),
      });
    });
    return temp;
  };

  private renderMemberData(summary: StatisticSummary, summaryPeriod: StatisticSummaryByPeriod): void {
    if (this.syncIdProviders)
      this.memberData = [...this.commonMemberData, ...this.getSyncIdMemberData(this.syncIdProviders)];
    this.memberData.map(data => {
      const key: string = data.key;

      if (data.schema) {
        const schema: string = data.schema;
        const depth = 'memberType' as string;

        if (schema === 'memberType') {
          data.tdData[0].content = summary[depth][key];
          data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[depth][key]).toFixed(2);
          data.tdData[2].content = summaryPeriod[depth][key];
          data.tdData[3].content = getPercentage(summaryPeriod.totalMemberCount, summaryPeriod[depth][key]).toFixed(2);
          data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[depth][key]).toFixed(2);
          data.tdData[5].content = getPercentage(summary[depth][key], summaryPeriod[depth][key]).toFixed(2);
        } else {
          data.tdData[0].content = summary[depth][schema][key];
          data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[depth][schema][key]).toFixed(2);
          data.tdData[2].content = summaryPeriod[depth][schema][key];
          data.tdData[3].content = getPercentage(
            summaryPeriod.totalMemberCount,
            summaryPeriod[depth][schema][key],
          ).toFixed(2);
          data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[depth][schema][key]).toFixed(
            2,
          );
          data.tdData[5].content = getPercentage(
            summary[depth][schema][key],
            summaryPeriod[depth][schema][key],
          ).toFixed(2);
        }
      } else {
        data.tdData[0].content = summary[key];
        data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[key]).toFixed(2);
        data.tdData[2].content = summaryPeriod[key];
        // legacy
        const hundredPercent = 100;
        data.tdData[3].content = hundredPercent.toFixed(2);
        // data.tdData[3].content = getPercentage(summaryPeriod.totalMemberCount, summaryPeriod[key]).toFixed(2)
        data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[key]).toFixed(2);
        data.tdData[5].content = getPercentage(summary[key], summaryPeriod[key]).toFixed(2);
      }
    });
  }

  private genderTdFormat = () => [
    { content: '0', labelName: 'allPeriodMemberCount' },
    { content: '0.00', labelName: 'allPeriodMemberRate' },
    { content: '0', labelName: 'searchDateMemberCount' },
    { content: '0.00', labelName: 'allPeriodMemberRate' },
    { content: '0.00', labelName: 'searchDateMemberRate' },
    { content: '0.00', labelName: 'searchDateMemberRate' },
  ];
  private genderData = [
    {
      key: 'totalMemberCount',
      thData: [{ content: 'STATISTIC_MEMBER_TOTAL' }],
      tdData: this.genderTdFormat(),
    },
    {
      key: 'maleMemberCount',
      schema: 'gender',
      thData: [{ content: 'STATISTIC_MEMBER_MALE' }],
      tdData: this.genderTdFormat(),
    },
    {
      key: 'femaleMemberCount',
      schema: 'gender',
      thData: [{ content: 'STATISTIC_MEMBER_FEMALE' }],
      tdData: this.genderTdFormat(),
    },
    {
      key: 'unclassifiedMemberCount',
      schema: 'gender',
      thData: [{ content: 'STATISTIC_MEMBER_UNCLASSIFIED' }],
      tdData: this.genderTdFormat(),
    },
  ];

  private renderGenderData(summary: StatisticSummary, summaryPeriod: StatisticSummaryByPeriod): void {
    this.genderData.map(data => {
      const key: string = data.key;

      if (data.schema) {
        const schema: string = data.schema;

        data.tdData[0].content = summary[schema][key];
        data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[schema][key]).toFixed(2);
        data.tdData[2].content = summaryPeriod[schema][key];
        data.tdData[3].content = getPercentage(summaryPeriod.totalMemberCount, summaryPeriod[schema][key]).toFixed(2);
        data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[schema][key]).toFixed(2);
        data.tdData[5].content = getPercentage(summary[schema][key], summaryPeriod[schema][key]).toFixed(2);
      } else {
        data.tdData[0].content = summary[key];
        data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[key]).toFixed(2);
        data.tdData[2].content = summaryPeriod[key];
        // legacy
        const hundredPercent = 100;
        data.tdData[3].content = hundredPercent.toFixed(2);
        //data.tdData[3].content = getPercentage(summaryPeriod.totalMemberCount, summaryPeriod[key]).toFixed(2)
        data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[key]).toFixed(2);
        data.tdData[5].content = getPercentage(summary[key], summaryPeriod[key]).toFixed(2);
      }
    });
  }

  private joinRouteTdFormat = () => [
    { content: '0', labelName: 'allPeriodMemberCount' },
    { content: '0.00', labelName: 'allPeriodMemberRate' },
    { content: '0', labelName: 'searchDateMemberCount' },
    { content: '0.00', labelName: 'allPeriodMemberRate' },
    { content: '0.00', labelName: 'searchDateMemberRate' },
    { content: '0.00', labelName: 'searchDateMemberRate' },
  ];
  private joinRouteData = [
    {
      key: 'totalMemberCount',
      thData: [{ content: 'STATISTIC_MEMBER_TOTAL' }],
      tdData: this.joinRouteTdFormat(),
    },
    {
      key: 'pcMemberCount',
      schema: 'joinRoute',
      thData: [{ content: 'STATISTIC_MEMBER_PLATFORM_TYPE_PC' }],
      tdData: this.joinRouteTdFormat(),
    },
    {
      key: 'mobileWebMemberCount',
      schema: 'joinRoute',
      thData: [{ content: 'STATISTIC_MEMBER_PLATFORM_TYPE_MOBILE_WEB' }],
      tdData: this.joinRouteTdFormat(),
    },
    {
      key: 'mobileAppMemberCount',
      schema: 'joinRoute',
      thData: [{ content: 'STATISTIC_MEMBER_PLATFORM_TYPE_MOBILE_APP' }],
      tdData: this.joinRouteTdFormat(),
    },
  ];

  private renderJoinRouteData(summary: StatisticSummary, summaryPeriod: StatisticSummaryByPeriod): void {
    this.joinRouteData.map(data => {
      const key: string = data.key;

      if (data.schema) {
        const schema: string = data.schema;

        data.tdData[0].content = summary[schema][key];
        data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[schema][key]).toFixed(2);
        data.tdData[2].content = summaryPeriod[schema][key];
        data.tdData[3].content = getPercentage(summaryPeriod.totalMemberCount, summaryPeriod[schema][key]).toFixed(2);
        data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[schema][key]).toFixed(2);
        data.tdData[5].content = getPercentage(summary[schema][key], summaryPeriod[schema][key]).toFixed(2);
      } else {
        data.tdData[0].content = summary[key];
        data.tdData[1].content = getPercentage(summary.totalMemberCount, summary[key]).toFixed(2);
        data.tdData[2].content = summaryPeriod[key];
        // legacy
        const hundredPercent = 100;
        data.tdData[3].content = hundredPercent.toFixed(2);
        // data.tdData[3].content = getPercentage(summaryPeriod.totalMemberCount, summaryPeriod[key]).toFixed(2)
        data.tdData[4].content = getPercentage(summary.totalMemberCount, summaryPeriod[key]).toFixed(2);
        data.tdData[5].content = getPercentage(summary[key], summaryPeriod[key]).toFixed(2);
      }
    });
  }

  private changeQuery() {
    this.$emit('changeQuery');
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
}
